import React, {
  useEffect,
  useState
} from "react";
import SimpleGrid, {
  BodyProps,
  CellProps
} from "components/shared/SimpleGrid/SimpleGrid";
import Button from "components/shared/Button/Button";
import { toLocalTime } from "helpers/variables";
import {
  CircularProgress,
  Stack,
  Box
} from "@mui/material";
import { orderInterface } from "api/kore/orders";
import API from "api";
import { GlobalContext } from "context/Provider";
import {useNavigate} from "react-router-dom";
import Session from "../../helpers/session";

export default function Orders() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [historicalOrders, setHistoricalOrders] = useState<orderInterface[]>(
    []
  );
  const [historicalOrdersTotal, setHistoricalOrdersTotal] = useState<number>(0);

  const orderHeaders: CellProps[] = [
    { content: "ID", align: "left" },
    { content: "Ordered on", align: "left" },
    { content: "Shipped on", align: "left" },
    { content: "Delivered", align: "left" },
    { content: "Organization", align: "left" },
    { content: "Requested by", align: "left" },
    { content: "Total items", align: "left" }
  ];

  const formatBody = (): BodyProps[] => {
    return historicalOrders
      .map((order): BodyProps => {
        return {
          cells: [
            { content: order._id || "", align: "left" },
            { content: toLocalTime(order.issuedOn || ""), align: "left" },
            { content: order.shippedOn || "", align: "left" },
            { content: order.fulfilled ? "√" : "" || "", align: "left" },
            { content: order.organization || "", align: "left" },
            { content: order.issuedBy || "", align: "left" },
            { content: `${order.manifest?.totalItems}` || "0", align: "left" }
          ]
        };
      })
      .reverse();
  };

  useEffect(() => {
    API.kore.orders.getAll(Session.crackCookieToken("provider")).then((orders) => {
      setHistoricalOrdersTotal(orders.length);
      paginationAction(5, 0);
    });
  }, []);

  const paginationAction = (itemsPerPage?: number, currentPage?: number) => {
    API.kore.orders
      .getAll(Session.crackCookieToken("provider"), `limit=${itemsPerPage}&page=${currentPage}`)
      .then((orders) => {
        setHistoricalOrders(orders);
      });
  };
  return (
    <Box sx={{ padding: 2 }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
        <h3>Order History</h3>
        <Button
          variant="primary"
          onClick={() => navigate("/provider/orders/new")}
        >
          + New Order
        </Button>
      </Stack>
      {loading ? (
        <CircularProgress size={60} />
      ) : (
        <SimpleGrid
          headers={orderHeaders}
          body={formatBody()}
          paginationAction={paginationAction}
          totalList={historicalOrdersTotal}
        />
      )}
    </Box>
  );
}
